/**
 * In-memory CSRF token of the current session (never persisted).
 * Set by the viewer entity from login/register/`/auth/me` responses; the API
 * client sends it as `X-CSRF-Token` on unsafe requests.
 */
let csrfToken: string | null = null;

export function setCsrfToken(token: string | null): void {
  csrfToken = token;
}

export function getCsrfToken(): string | null {
  return csrfToken;
}
